module.exports = __webpack_public_path__ + "static/img/cirle.0259a64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/活动模板/cirle.png
// module id = l+lE
// module chunks = 0